var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("status " + (_vm.setStatusColor())),on:{"click":_vm.setStatus}})}
var staticRenderFns = []

export { render, staticRenderFns }